export type PlanningPhaseId = 'setup' | 'research' | 'confirmation' | 'execution' | 'final-countdown';

export interface DataMilestone {
  id: string;
  label: string;
  check: (data: PhaseData) => boolean;
}

export interface PhaseData {
  vendors: Array<{ category?: string; tags?: string[] }>;
  guests: Array<unknown>;
  budgetCategories: Array<unknown>;
  tasks: Array<{ phase?: string; status: string; taskType?: string }>;
}

export const DATA_MILESTONES: Record<PlanningPhaseId, DataMilestone[]> = {
  'setup': [
    { id: 'events-defined', label: 'Events defined', check: () => true },
    { id: 'guests-started', label: 'Guest list started (≥20 guests)', check: d => d.guests.length >= 20 },
    { id: 'budget-started', label: 'Budget framework set up', check: d => d.budgetCategories.length >= 5 },
  ],
  'research': [
    { id: 'vendors-10', label: '10+ vendors in system', check: d => d.vendors.length >= 10 },
    { id: 'venue-exists', label: 'Venue vendor researched', check: d => d.vendors.some(v => (v.category || '').toLowerCase().includes('venue')) },
    { id: 'photo-exists', label: 'Photographer researched', check: d => d.vendors.some(v => (v.category || '').toLowerCase().includes('photo')) },
    { id: 'guests-100', label: 'Guest list at 100+', check: d => d.guests.length >= 100 },
    { id: 'budget-full', label: 'Budget fully planned', check: d => d.budgetCategories.length >= 10 },
  ],
  'confirmation': [
    { id: 'vendors-20', label: '20+ vendors confirmed', check: d => d.vendors.length >= 20 },
    { id: 'guests-200', label: 'Guest list at 200+', check: d => d.guests.length >= 200 },
  ],
  'execution': [
    { id: 'vendors-all', label: 'All key vendors booked', check: d => d.vendors.length >= 25 },
  ],
  'final-countdown': [],
};

export const PHASE_TASK_WEIGHT = 0.6;
export const PHASE_MILESTONE_WEIGHT = 0.4;
